import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';

import { AbstractPropertyEditorBase } from '../../types/property-editor.types';
import { ZrCounterComponent } from 'zr-counter';

@Component({
  selector: 'df-number-property-editor',
  templateUrl: './number-property-editor.component.html',
  styleUrls: ['./number-property-editor.component.scss']
})
export class NumberPropertyEditorComponent extends AbstractPropertyEditorBase implements OnInit, AfterViewInit {
  @Input() min: number = 0;
  @Input() max: number = 100;

  @ViewChild('zrCounter') zrCounter: ElementRef;
  constructor() {
    super();
  }

  ngOnInit() {}

  ngAfterViewInit(): void {
    // TODOï¼å ä¸ºzr-countä¸æ¯æç¦ç¨ï¼æªæ¥çæ¬æ¯æåï¼è¿æ®µä»£ç å¯ä»¥ç§»é¤æ
    const div = this.zrCounter.nativeElement as HTMLDivElement;
    div.querySelectorAll('input').forEach((s) => {
      if (this.disabled) {
        s.setAttribute(`disabled`, `disabled`);
      }
    });
    div.querySelectorAll('button').forEach((s) => {
      if (this.disabled) {
        s.setAttribute(`disabled`, `disabled`);
      }
    });
  }
}
